<template>
  <!-- <div id="container"></div> -->
  <amap
    :center.sync="center"
    :zoom="zoom"
    :style="{ opacity: opacityShow }"
    @mousewheel="mousewheelChange"
    @mouseover="mouseoverChange"
  >
    <amap-map-type
      :visible="visible"
      :showTraffic="false"
      :showRoad="false"
      :defaultType="1"
    />
    <div v-for="(item, index) in clusterData" :key="index">
      <amap-marker
        :position.sync="item.value"
        :anchor="anchor"
        :offset="[0, -220]"
      >
        <div>
          <div class="marker">
            <div class="pop-content flex flex-direction align-items" v-show="flagIndex == index">
              <div class="text-xsss text-left">{{ item.stationName }}</div>
              <div class="pop-img flex align-center justify-center">
                <img
                  :src="`${
                    item.station_type === '换电站' ? car_bg : car_chongdian
                  }`"
                />
              </div>
            <div v-if="item.station_type === '换电站'" class="text-xsss text-center">
                   可换{{ item.houseTotalBatteries || 0 }}，排队{{
                     item.lineUpNum || 0
                   }}
                 </div>
                 <div v-else class="text-xsss text-center">
                   空闲{{ item.houseTotalBatteries || 0 }}，排队{{
                     item.lineUpNum || 0
                   }}
                 </div>
            </div>
            <div class="diamand flex justify-center justify-content" @click="clickArea(index,item)">
              <img class="diamand1" :src="`${area_diamond}`" />
              <!-- <img class="diamand2" :src="`${area_diamond2}`" /> -->
            </div>
          </div>
        </div>
      </amap-marker>
    </div>
  </amap>
</template>
  
  <script>
// import AMapLoader from '@amap/amap-jsapi-loader'
import { dataInterface } from "@/api/dataInterfaceApi";
import area_diamond from "@/assets/images/index/area_diamond.png";
import area_diamond2 from "@/assets/images/index/area_diamond2.png";
import car_bg from "@/assets/images/index/car-bg1.png";
import car_chongdian from "@/assets/images/index/car_chongdian.jpg";
export default {
  components: {},
  data() {
    return {
      plugin: [
        {
          pName: "MapType",
          defaultType: 1, //0代表默认，1代表卫星
          showTraffic: false, // 路网
          showRoad: true, // 路况
        },
      ],
      center: [110, 32],
      clusterData: [],
      anchor: "center",
      visible: false,
      params: {
        longitudeStart: "",
        latitudeStart: "",
        vehicleVin: "",
      },
      listDatas: [],
      car: {
        // path[0].slice(0)
        // pos: path[0].slice(0), // 小车icon的坐标，为空不能设置该key.
        // angle: (Math.atan2(dy, dx) * 180) / Math.PI,
        icon: {
          image: "https://jimnox.gitee.io/amap-vue/assets/car.png",
          imageSize: [26, 50],
        },

        offset: [-13, -25],
      },
      geoJson: {
        features: [],
      },
      zoom: 12,
      area_diamond: area_diamond,
      area_diamond2: area_diamond2,
      car_bg: car_bg,
      car_chongdian: car_chongdian,
      opacityShow: 0,
      isShow: false,
      flagIndex: -1
    };
  },
  created() {
    // this.zoom = this.$route.query.zoom * 1 || 6;
    // this.center = this.$route.query.center || [110, 32];
    // let cityCode = this.$route.query.province
    //   ? this.$route.query.province
    //   : this.$route.query.city;
    // console.log(this.$route.query.level, "级别");
    // if (this.$route.query.level == "province") {
    //   console.log("当前-省");
    //   this.selectProvinceStationInfo(cityCode);
    // } else if (
    //   this.$route.query.level == "city" &&
    //   this.$route.query.name != "石河子市"
    // ) {
    //   console.log("当前-市", cityCode);
    //   this.selectCityStationInfo(cityCode);
    // } else if (
    //   this.$route.query.level == "district" ||
    //   this.$route.query.name == "石河子市"
    // ) {
    //   console.log("当前-区");
    //   this.selectDistrictStationInfo(cityCode);
    //   // this.$router.push({
    //   //     path: "/newVehicleControl",
    //   //     query: {
    //   //       city: item.cityCode,
    //   //       // name: item.name,
    //   //       cityName: item.name,
    //   //       value:item.value,
    //   //       zoom: 13,
    //   //       level: item.level,
    //   //       center: item.value
    //   //     },
    //   //   });
    // } else {
      this.init();
    // }

  },
  mounted() {},
  methods: {
    mouseoverChange(e) {
      console.log(e);
    },
    mousewheelChange(e) {
      console.log(e, "地图缩放");
    },
    init(city, vehicleVin) {
      let that = this;
      console.log(city);
      // that.center = [110, 32];
      // this.params.vehicleVin = vehicleVin ? vehicleVin : "";
      this.selectDistrictStationInfo();
    },
    clickArea(index,item){
      this.flagIndex = index
      this.$EventBus.$emit('label',item)
    },

    sumArrayFields2(arr) {
      let sums = {};
      for (let i = 0; i < arr.length; i++) {
        // let provinceName =  arr[i].provinceName
        let district = arr[i].district;
        let chongdianzhuang = parseInt(arr[i].chongdianzhuang);
        let huandianzhan = parseInt(arr[i].huandianzhan);

        if (sums[district]) {
          sums[district].chongdianzhuang += chongdianzhuang;
          sums[district].huandianzhan += huandianzhan;
          // sums[province].provinceName = provinceName
        } else {
          sums[district] = {
            chongdianzhuang: chongdianzhuang,
            huandianzhan: huandianzhan,
          };
        }
      }

      let result = [];
      for (let district in sums) {
        result.push({
          // provinceName: sums.provinceName,
          district: district,
          chongdianzhuang: sums[district].chongdianzhuang,
          huandianzhan: sums[district].huandianzhan,
        });
      }

      return result;
    },
    //获取区级换电站数据
    selectDistrictStationInfo(curAdcode) {
      let params = {
        enCode: "TiDB-zhandian-zhandianjingweidu", //TiDB-全国地图
        "@province": 440111,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          //   this.stationList = res || [];
        console.log(res, params,"区级站点数据");
          this.clusterData = res.map((item) => {
            return {
              value: [Number(item.longitude), Number(item.latitude)],
              houseTotalBatteries: item.houseTotalBatteries,
              id: item.id,
              stationName: item.stationName,
              station_type: item.station_type,
              detailed_address: item.detailed_address
            };
          });
          console.log(this.clusterData, "区级站点数据");
          this.center = this.clusterData[10].value;
          localStorage.setItem('clusterData', JSON.stringify(this.clusterData))
          setInterval(() => {
            this.opacityShow = 1;
          }, 2500);
          // this.getGeoJson1(adcode, curAdcode, res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  filters: {},
  // 销毁定时器
  beforeDestroy: function () {},
};
</script>
  

<style>
.amap-logo {
  display: none !important;
}
.amap-copyright {
  visibility: hidden !important;
}

.amap-maptypecontrol {
  display: none !important;
}
</style>

  <style scope lang="scss">
@import "@/assets/scss/comm.scss";

// 弹窗1.0
.mapBg {
  width: 250px;
  height: 185px;
  .marsbg {
    width: 100%;
    height: 82px;
    background: url("~@/assets/images/comm/marsBlue.png");
    background-size: 100% 100%;
    opacity: 0.9;
    .vehicleIconImg {
      width: 20px;
      height: 20px;
      background: url("~@/assets/images/comm/vehicleIcon.jpg");
      background-size: 100% 100%;
    }
    .itemNumber {
      // margin-left: 20px;
      font-size: 48px;
      color: #fff;
      @include ffamily-DS;
    }
  }
  .marsblue {
    width: 50px;
    height: 50px;
    background: url("~@/assets/images/comm/blue.png");
    // background: url("~@/assets/images/vehicles/orange.png");
    background-size: 100% 100%;
    animation: Beating 1.2s ease infinite;
  }
  .marsbottom {
    width: 37px;
    height: 27px;
    background: url("~@/assets/images/comm/blueBottom.png");
    background-size: 100% 100%;
    animation: breath_light 3s ease infinite;
  }
}

.marsBoxBg {
  width: 400px;
  height: 60px;
  // background: red;
  background: url("~@/assets/images/index/double-bg.png");
  background-size: 100% 100%;
  opacity: 0.6;
}

.m-r-40 {
  margin-left: 25px;
}
.m-r-35 {
  margin-left: 35px;
}
.m-r-15 {
  margin-right: 15px;
}
.m-t-20 {
  margin-top: 20px;
}
.font-15 {
  font-size: 15px;
}
.font-20 {
  font-size: 18px;
}
.marker {
  // background-image: url('mapbox-icon.png');
  background-size: cover;
  width: 165px;
  height: 45px;
  cursor: pointer;
  z-index: 1000;
}
.mapboxgl-popup {
  max-width: 200px;
}
.mapboxgl-popup-content {
  //气泡内容部分
  left: 50%;
  text-align: center;
  background: transparent;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.mapboxgl-popup-tip {
  border: 0;
}
.mapboxgl-popup-close-button {
  display: none;
}

.pop-content {
  background: url("~@/assets/images/index/area_bg.png");
  width: 222px;
  height: 184px;
  background-size: 100% 100%;
  padding: 5px 15px;
  cursor: pointer;
  .pop-img {
    flex: 1;
    padding: 5px 0;
    img {
      width: 100%;
      border: 1px solid rgba(120, 250, 255, 0.43);
    }
  }
}
.diamand {
  margin-top: 20px;
  margin-bottom: 20px;
  // margin-left:20%;
  position: relative;
  .diamand2 {
    width: 60px;
    height: 36px;
    position: absolute;
    bottom: -30px;
    left: 36%;
  }
  .diamand1 {
    width: 46px;
    height: 52px;
    animation: bounce-down 1.5s linear infinite;
  }
}
@keyframes bounce-down {
  25% {
    transform: translateY(-10px);
  }
  50%,
  100% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(10px);
  }
}

li.bge5 {
  background-color: #e5e5e5;
}

.marsMapBgTop1 {
  width: 214px;
  height: 60px;
  background: url("~@/assets/images/index/marsMapBgTop1.png") repeat;
  background-size: 100% 100%;
  padding-top: 30px;
}
.marsMapBgBottom1 {
  width: 214px;
  height: 95px;
  background: url("~@/assets/images/index/marsMapBgBottom1.png") repeat;
  background-size: 100% 100%;
}
.marsMapBgAll {
  width: 228px;
  height: 138px;
  background: url("~@/assets/images/index/mapBg.png") repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  padding-top: 30px;
}

.marsMapBg1 {
  width: 214px;
  /* height: 128px; */
  background: url("~@/assets/images/index/mapBgCenter1.png") repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.huandianzhan-icon {
  position: relative;
  width: 50%;
  // padding-left: 30px;
  font-weight: 800;
}
.huandianzhan-icon::before {
}
.huandianzhan::before {
  content: "";
  background: url("~@/assets/images/index/huandian-icon-1.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 30px;
  height: 20px;
  margin-right: 40px;
  left: 0;
}
.yellow {
  font-weight: 800;
  color: #fedc31;
}

.huandianzhan.yellow::before {
  content: "";
  background: url("~@/assets/images/index/huandianzhanY.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 30px;
  height: 20px;
  margin-right: 40px;
  left: 0;
}

.green {
  font-weight: 800;
  color: #36fbfb;
}
.huandianzhan.green::before {
  content: "";
  background: url("~@/assets/images/index/huandianzhanG.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 30px;
  height: 20px;
  margin-right: 40px;
  left: 0;
}

.chongdianzhuang.green::before {
  content: "";
  background: url("~@/assets/images/index/chongdianzhuangG.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 25px;
  height: 24px;
  margin-right: 35px;
  left: 0;
}
.chongdianzhuang.yellow::before {
  content: "";
  background: url("~@/assets/images/index/chongdianzhuangY.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 25px;
  height: 24px;
  margin-right: 35px;
  left: 0;
}
.chongdianzhuang::before {
  content: "";
  background: url("~@/assets/images/index/chongdian-icon-1.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 25px;
  height: 24px;
  margin-right: 35px;
  left: 0;
}
</style>